theme = {
  init: function () {
    theme.singleProduct();
    theme.openData();
    theme.slickSwitchImage();
    theme.openFilterType();
  },
  singleProduct: function () {
    if ($(".product-template").length > 0) {
      var id = $(".product-template").data("id");
      $(".main-image-" + id).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: true,
        asNavFor: ".nav-main-image-" + id,
      });
      $(".nav-main-image-" + id).slick({
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: ".main-image-" + id,
        dots: false,
        infinite: true,
        focusOnSelect: true,
        margin: 0,
      });
    }
  },
  openData: function () {
    $(".active-collapse").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this)
        .parents(".block-info")
        .siblings()
        .find(".active-collapse")
        .removeClass("active");
      $(this)
        .parents(".block-info")
        .siblings()
        .find(".collapse")
        .removeClass("active");
      $(this)
        .parents(".block-info")
        .find($(this).data("target"))
        .toggleClass("active");
    });
  },
  slickSwitchImage: function () {
    var id;
    $(".product-quick-view").on("click", function (e) {
      e.preventDefault();
      id = $(this).data("id");
      if ($(this).hasClass("slicked") == false) {
        $(this).addClass("slicked");
        $(".main-image-" + id).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: ".nav-main-image-" + id,
        });
        $(".nav-main-image-" + id).slick({
          arrows: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: ".main-image-" + id,
          dots: false,
          infinite: false,
          focusOnSelect: true,
          margin: 0,
        });
        //Clicks on First Color Variant
        $("#quick-view-content-" + id)
          .find(".single-product-data .switch-color-element")
          .first()
          .trigger("click");
      }
      $("#quick-view-content-" + id).addClass("active");
      $(".global-opaque-background").addClass("active");
    });
    $(".close-modal").on("click", function (e) {
      e.preventDefault();
      $(this).parents(".quick-view-container").removeClass("active");
      $(".global-opaque-background").removeClass("active");
    });
  },
  openFilterType: function () {
    $(".filter-type").on("click", function (e) {
      e.preventDefault();
      $(this).parents("li").toggleClass("active");
      $(this).parents("li").siblings("li").removeClass("active");
    });
    $(".title-mobile").on("click", function (e) {
      e.preventDefault();
      $(".filters-products").toggleClass("active");
    });
  },
};
theme.init();
SlideShow = {
  init: function () {
    $(".slide-show").each(function () {
      var id = $(this).data("id");
      SlideShow.build(id);
    });
  },
  build: function (id) {
    var slide = $("#slide-show-" + id);
    var options = slide.data("options");
    slide.slick({
      arrows: true,
      autoplay: options.autoplay,
      autoplaySpeed: options.autoplaySpeed,
      infinite: options.infinite,
      vertical: options.vertical,
      verticalSwiping: options.vertical,
      slidesToShow: 1,
    });
  },
};
SlideShow.init();
ListCollection = {
  init: function () {
    $(".slide-list-collection").each(function () {
      var id = $(this).data("id");
      ListCollection.build(id);
    });
  },
  build: function (id) {
    var slide = $("#list-collection-" + id);
    var options = slide.data("options");
    if (options.slick == false) {
      return;
    }
    slide.slick({
      arrows: false,
      autoplay: options.autoplay,
      autoplaySpeed: options.autoplaySpeed,
      infinite: options.infinite,
      responsive: [
        {
          breakpoint: 4000,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};
ListCollection.init();
ListRelated = {
  init: function () {
    if ($(".list-related").length > 0) {
      ListRelated.build();
    }
  },
  build: function () {
    var slide = $(".list-related");
    var number = slide.data("number");
    slide.slick({
      arrows: false,
      infinite: false,
      slidesToScroll: 1,
      dots: number > 3 ? true : false,
      responsive: [
        {
          breakpoint: 4000,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};
ListRelated.init();
$(document).on("shopify:section:select", function (event) {
  var data = event.target.attributes;
  var array;
  for (var i in data) {
    if (data[i].nodeValue.indexOf("}") > 0) {
      array = data[i].nodeValue;
      break;
    }
  }
  console.log(JSON.parse(array));
  var section = JSON.parse(array);
  switch (section.type) {
    case "slide-show":
      SlideShow.build(section.id);
      break;
    case "list-collections":
      ListCollection.build(section.id);
      break;
    case "product-template":
      ListRelated.build();
      break;
  }
});
